import { useSuspenseQuery } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { t } from 'i18next'
import { useNavigate } from 'react-router'

import { GetAtendimentoAtivoService } from '@/features/atendimento/shared/http/get-atendimento-ativo.service'
import { useLocalStorage } from '@/hooks/use-local-storage'
import { showToast } from '@/infra'
import type { TAtendimento } from '@/types/atendimento'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useSuspenseAtendimento = () => {
  const [, setAtendimento] = useLocalStorage<TAtendimento | null>('atendimento', null)
  const navigate = useNavigate()
  return useSuspenseQuery({
    gcTime: 0,
    staleTime: 0,
    queryKey: atendimentoKeys.atendimentoAtivo(),
    queryFn: async () => {
      try {
        const result = await new GetAtendimentoAtivoService().execute()
        setAtendimento(result)
        return result
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          setAtendimento(null)
          showToast({
            message: t('atendimento:errors.ja_encerrado'),
            variant: 'info',
          })
          navigate('/es-CL')
        }
        return null
      }
    },
  })
}
